import React from "react";
import trans from "../../../../utils";
import { InputDate, InputPermissions } from "../../../Helpers/Input/Input";
import { useGetMyPermissionsQuery } from "../../../../Redux/service/Roles&Permissions/RolesPermissions";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import dayjs from "dayjs";

export default function RolesSettings({ addData }) {
	const { data: PermissionsData } = useGetMyPermissionsQuery(
		{ userType: addData?.values?.userType },
		{ skip: !addData?.values?.userType },
	);
	const statusOptions = [
		{ label: trans("Active"), value: true },
		{ label: trans("Inactive"), value: false },
	];
	return (
		<>
			<div className="userinfo mb-24">
				<p className="fs-16 fw-700 brand-700 text-uppercase">
					{trans("permissions")}
				</p>
				<div className="row">
					<div className="col-lg-12">
						<InputPermissions
							title={trans("Permissions")}
							type="permissions"
							data={
								PermissionsData?.data?.map((i) => {
									return {
										label: `${i.name}`,
										value: i.id,
									};
								}) || []
							}
							id="permissions"
							name="permissions"
							onBlur={addData.handleBlur}
							onChange={(e) => addData.setFieldValue("permissions", e ?? null)}
							errors={addData.errors.permissions}
							touched={addData.touched.permissions}
							value={
								addData.values.permissions ??
								addData.values.rolePermissions?.map((i) => i?.permission?.id) ??
								[]
							}
							mode="multiple"
							disabled={!addData?.values?.userType}
						/>
					</div>
				</div>
			</div>
			<div className="userinfo mb-24">
				<p className="fs-16 fw-700 brand-700 text-uppercase">
					{trans("Settings")}
				</p>
				<div className="row">
					<div className="col-lg-6">
						<InputSelect
							label="status"
							name="isActive"
							id="isActive"
							options={statusOptions}
							placeholder={trans("Select Status")}
							formstyle="form-input"
							onBlur={(e) => addData.handleBlur(e)}
							onChange={(value) => addData.setFieldValue("isActive", value)}
							value={
								!addData.values.isActive
									? trans("Inactive")
									: addData.values.isActive
							}
							allowClear={false}
						/>
					</div>
					<div className="col-lg-6">
						<InputDate
							title={trans("Role Expiration Date")}
							id="expiry"
							name="expiry"
							onBlur={(value) => addData.setFieldTouched("expiry", true)}
							onChange={(value) =>
								addData.setFieldValue(
									"expiry",
									value ? dayjs(value).toISOString() : "",
								)
							}
							errors={addData?.errors?.expiry}
							touched={addData?.touched?.expiry}
							value={addData?.values?.expiry || ""}
							disabled={!addData?.values?.isActive}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
